module.exports = __webpack_public_path__ + "static/media/web_superhighway.72828670.webp";